import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useLocation } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

const EditTemplate = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  const usernameRef = useRef(null);
  const id = searchParams.get("id");

  const [initialValues, setInitialValues] = useState({
    gradeid: "",
    questions: [
      { category: "", subcategory: "", text: "", yesNo: false, rating: 0 },
    ],
  });
  const [template, setTemplate] = useState(initialValues);

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [options, setOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [editedText, setEditedText] = useState({});

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/gettemplatedetails?id=` + id
        );
        let temp = response.data.template;
        let qjson = temp[0].questionsJSON;
        let tjson = JSON.parse(qjson);
        setTemplate(tjson);
        setInitialValues(tjson);
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    };
    fetchTemplate();
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`${baseURL}/allgrades`);
        setOptions(response.data.grades);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const resp = await axios.get(`${baseURL}/getcategories`);
        setCategories(resp.data.categories);
        showAllsubcat();
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const showFormGrid = async (parentid) => {
    try {
      const resp = await axios.get(
        `${baseURL}/getsubcategorieforcatid?id=` + parentid
      );
      setSubcategories(resp.data.subcategories);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const showAllsubcat = async () => {
    try {
      const resp = await axios.get(`${baseURL}/getallsubcategories`);
      setSubcategories(resp.data.subcategories);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const handleSubmit = (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true);
  };

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    setEditedText((prevState) => ({
      ...prevState,
      [index]: value,
    }));
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditedText({});
  };

  const handleConfirmSubmit = async () => {
    try {
      const jsonData = JSON.stringify(formData);

      const response = await fetch(`${baseURL}/addtemplatemaster`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: jsonData,
      });

      if (response.ok) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/createTemplateTab");
        }, 3000);
        // window.location.href = "/createTemplateTab";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div className="form-container">
      <h4>Edit Appraisal Template</h4>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values, handleChange, handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="grade">Grade</label>
              <Field
                as="select"
                id="grade"
                name="grade"
                value={(values.gradeid = template.gradeid)}
              >
                <option value="">Select Grade</option>
                {options.map((option) => (
                  <option
                    key={option.id}
                    value={option.id}
                    selected={template.gradeid == option.id}
                  >
                    {option.gradename}
                  </option>
                ))}
              </Field>
            </div>
            <table className="appraisal-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Subcategory</th>
                  <th>Question</th>
                  <th>Yes/No</th>
                  <th>Rating</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <FieldArray name="questions">
                  {({ push, remove }) => (
                    <>
                      {template.questions.map((question, index) => (
                        <tr key={index}>
                          <td>
                            <Field
                              as="select"
                              name={`questions.${index}.category`}
                              onChange={(e) => {
                                handleChange(e);
                                showFormGrid(e.target.value);
                              }}
                              className="category-select"
                              value={question.category}
                            >
                              <option value="">Select Category</option>
                              {categories.map((category) => (
                                <option key={category.id} value={category.id}>
                                  {category.categoryname}
                                </option>
                              ))}
                            </Field>
                          </td>
                          <td>
                            <Field
                              as="select"
                              name={`questions.${index}.subcategory`}
                              className="subcategory-select"
                              value={question.subcategory}
                            >
                              <option value="">Select Subcategory</option>
                              {subcategories.map((subcategory) => (
                                <option
                                  key={subcategory.id}
                                  value={subcategory.id}
                                  selected={
                                    parseInt(question.subcategory) ===
                                    parseInt(subcategory.id)
                                  }
                                >
                                  {subcategory.subcategoryname}
                                </option>
                              ))}
                            </Field>
                          </td>
                          <td>
                            <Field
                              as="textarea"
                              name={`questions.${index}.text`}
                              value={
                                editedText[index] !== undefined
                                  ? editedText[index]
                                  : question.text
                              }
                              onChange={(e) => handleChange(e, index)}
                            />
                          </td>
                          <td>
                            <Field
                              type="checkbox"
                              name={`questions.${index}.yesNo`}
                              checked={question.yesNo}
                              value={values.questions[index]?.yesNo}
                            />
                          </td>
                          <td>
                            <Field
                              type="number"
                              name={`questions.${index}.rating`}
                              min="0"
                              max="100"
                              value={values.questions[index]?.rating}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              onClick={() => {
                                remove(index);
                                setTemplate((prevState) => ({
                                  ...prevState,
                                  questions: prevState.questions.filter(
                                    (_, i) => i !== index
                                  ),
                                }));
                              }}
                            >
                              Remove Question
                            </button>
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="6">
                          <button
                            type="button"
                            onClick={() => {
                              push({
                                category: "",
                                subcategory: "",
                                text: "",
                                yesNo: false,
                                rating: 0,
                              });
                              setTemplate((prevState) => ({
                                ...prevState,
                                questions: [
                                  ...prevState.questions,
                                  {
                                    category: "",
                                    subcategory: "",
                                    text: "",
                                    yesNo: false,
                                    rating: 0,
                                  },
                                ],
                              }));
                            }}
                          >
                            Add Question
                          </button>
                        </td>
                      </tr>
                    </>
                  )}
                </FieldArray>
              </tbody>
            </table>
            <div className="col-lg-11 text-end mt-4 pb-3">
              <Button
                className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                type="submit"
              >
                Save
              </Button>
              <a href="/createtemplatetab" className="text-decoration-none">
                <button
                  type="button"
                  className="btn cancelbtn ml-2"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </a>
            </div>
          </Form>
        )}
      </Formik>
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div>
  );
};

export default EditTemplate;
